import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./reject.css";
import { useDispatch } from "react-redux";
import { rejectEditRequest } from "../../modules/patientProfile/patientProfileThunk";
import ToastPopup from "../Toast/toastPopup";

const RejectEdit = ({ showModal, handleCancel, handleConfirm, reason, userId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");

  useEffect(() => {
    if (showModal) {
      setVisible(true);
    }
  }, [showModal]);

  const handleChange = (event) => {
    setRejectionReason(event.target.value.trimStart());
  };

  const handleCloseWithTransition = (callback) => {
    setVisible(false);
    setTimeout(() => {
      callback();
    }, 300);
  };

  const handleReject = (callback) => {
    if (!rejectionReason) {
      ToastPopup.error(t('emptyReason'));
      return;
    }
    if (rejectionReason.length < 10) {
      ToastPopup.error(t('minReason'));
      return;
    }
    dispatch(rejectEditRequest({ userId, rejectionReason }));
    setVisible(false);
    setTimeout(() => {
      callback();
    }, 300);
  };

  if (!showModal && !visible) return null;

  return (
    <div className="modal-reject-container">
      <div className={`modal-content-del reject ${visible ? "modal-open" : "modal-close"}`}>
        <div className="modal-header-del rej">
          <h2>{t(reason)}</h2>
        </div>
        <div className="modal-body-del reject">
          <textarea className="styled-textarea" placeholder={t("rejectReason")} value={rejectionReason} onChange={handleChange} />
        </div>
        <div className="modal-footer-del reject">
          <button className="modal-cancel-button speciality-cancel" onClick={() => handleCloseWithTransition(handleCancel)}>
            {t("cancel")}
          </button>
          <button className="modal-confirm-button speciality-save" onClick={() => handleReject(handleConfirm)}>
            {t("confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectEdit;
